import axios from "axios";
import dayjs from "dayjs";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("crm_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config.url.includes("/auth/login")) {
      localStorage.removeItem("crm_token");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d.message) return d.message;
  return String(d);
}

export const confirmDelete = async (path, what, onDone) => {
  if (!window.confirm(`Permanently delete this ${what}? This cannot be undone.`)) return;
  try { await api.delete(path); (await import("sonner")).toast.success(`${what[0].toUpperCase()}${what.slice(1)} deleted`); onDone && onDone(); }
  catch (e) { (await import("sonner")).toast.error(errMsg(e)); }
};

export const inr = (v) => "₹" + Math.round(Number(v || 0)).toLocaleString("en-IN");
export const inrShort = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1e7) return `₹${(n / 1e7).toFixed(2)}Cr`;
  if (Math.abs(n) >= 1e5) return `₹${(n / 1e5).toFixed(1)}L`;
  if (Math.abs(n) >= 1e3) return `₹${(n / 1e3).toFixed(0)}K`;
  return `₹${Math.round(n)}`;
};
export const fmtDT = (s) => (s ? dayjs(s).format("DD MMM YYYY, hh:mm A") : "—");
export const fmtD = (s) => (s ? dayjs(s).format("DD MMM YYYY") : "—");
export const fmtT = (s) => (s ? dayjs(s).format("hh:mm A") : "—");
export const toInput = (s) => (s ? dayjs(s).format("YYYY-MM-DDTHH:mm") : "");
export const toDateInput = (s) => (s ? dayjs(s).format("YYYY-MM-DD") : "");
export const fromInput = (v) => (v ? new Date(v).toISOString() : null);
export const today = () => dayjs().format("YYYY-MM-DD");
export const ago = (s) => {
  if (!s) return "—";
  const m = dayjs().diff(dayjs(s), "minute");
  if (m < 1) return "just now";
  if (m < 60) return `${m}m ago`;
  if (m < 1440) return `${Math.floor(m / 60)}h ago`;
  return `${Math.floor(m / 1440)}d ago`;
};

export const VERTICAL_STYLE = {
  BMS: "bg-amber-50 text-amber-700 border-amber-200",
  Intl: "bg-blue-50 text-blue-700 border-blue-200",
  Ind: "bg-emerald-50 text-emerald-700 border-emerald-200",
  CRM: "bg-violet-50 text-violet-700 border-violet-200",
};
export const VERTICAL_HEX = { BMS: "#f59e0b", Intl: "#3b82f6", Ind: "#10b981", CRM: "#8b5cf6" };

export const CALL_STYLE = {
  Connected: "bg-emerald-50 text-emerald-700", Qualified: "bg-emerald-100 text-emerald-800",
  "Call Back Requested": "bg-sky-50 text-sky-700", "Follow-up Required": "bg-sky-50 text-sky-700",
  "No Answer": "bg-amber-50 text-amber-700", Busy: "bg-amber-50 text-amber-700", Ringing: "bg-slate-100 text-slate-700",
  "Not Called": "bg-slate-100 text-slate-600", "Wrong Number": "bg-rose-50 text-rose-700",
  "Not Interested": "bg-rose-50 text-rose-700", Disqualified: "bg-rose-100 text-rose-800",
};
export const STATUS_STYLE = {
  Scheduled: "bg-blue-50 text-blue-700", Rescheduled: "bg-amber-50 text-amber-700", Completed: "bg-emerald-50 text-emerald-700",
  Cancelled: "bg-slate-100 text-slate-600", "No Show": "bg-rose-50 text-rose-700", Pending: "bg-blue-50 text-blue-700",
  Overdue: "bg-rose-50 text-rose-700", Won: "bg-emerald-100 text-emerald-800", Lost: "bg-rose-100 text-rose-800",
  Paid: "bg-emerald-50 text-emerald-700", Partial: "bg-amber-50 text-amber-700",
};
export const TASK_TYPES = ["Follow-up", "Call", "Email", "Meeting Prep", "Proposal", "Payment Follow-up", "Other"];
export const MEETING_TYPES = ["Video Call", "In-person", "Phone", "Site Visit", "Demo"];
export const PAYMENT_STATUSES = ["Pending", "Partial", "Paid"];
export const COLLECTION_STATUSES = ["Not Due", "Due", "Partially Collected", "Collected", "Overdue"];
